import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _slicedToArray from "/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { areaList, agentList, agentHandle, agentDelete } from '@/api/apis';
export default {
  name: 'regionShow',
  data: function data() {
    return {
      loading: false,
      areaTree: [],
      agentMap: {},
      filterStatus: '',
      filterKeyword: '',
      editDialog: {
        visible: false,
        occupied: false,
        districtId: '',
        districtCode: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        number: '',
        submitLoading: false,
        delLoading: false
      },
      editRules: {
        number: [{
          required: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    provinces: function provinces() {
      var _this = this;

      return this.areaTree.map(function (province) {
        var cities = (province.children || []).map(function (city) {
          var districts = (city.children || []).map(function (district) {
            var agent = _this.agentMap[district.id];
            return {
              id: district.id,
              name: district.name,
              code: district.code || district.id,
              provinceId: province.id,
              provinceName: province.name,
              cityId: city.id,
              cityName: city.name,
              occupied: !!agent,
              agentNumber: agent ? agent.number : ''
            };
          });
          return {
            id: city.id,
            name: city.name,
            districts: districts
          };
        });
        return {
          id: province.id,
          name: province.name,
          cities: cities
        };
      });
    },
    filteredProvinces: function filteredProvinces() {
      var _this2 = this;

      var kw = this.filterKeyword ? this.filterKeyword.toLowerCase() : '';
      return this.provinces.map(function (province) {
        var cities = province.cities.map(function (city) {
          var districts = city.districts.filter(function (d) {
            if (_this2.filterStatus === 'occupied' && !d.occupied) return false;
            if (_this2.filterStatus === 'free' && d.occupied) return false;

            if (kw) {
              var matchDistrict = d.name.toLowerCase().includes(kw);
              var matchAgent = d.agentNumber && d.agentNumber.toLowerCase().includes(kw);
              if (!matchDistrict && !matchAgent) return false;
            }

            return true;
          });
          return _objectSpread({}, city, {
            districts: districts
          });
        }).filter(function (c) {
          return c.districts.length > 0;
        });
        return _objectSpread({}, province, {
          cities: cities
        });
      }).filter(function (p) {
        return p.cities.length > 0;
      });
    },
    totalCount: function totalCount() {
      var count = 0;
      this.provinces.forEach(function (p) {
        return p.cities.forEach(function (c) {
          return count += c.districts.length;
        });
      });
      return count;
    },
    occupiedCount: function occupiedCount() {
      var count = 0;
      this.provinces.forEach(function (p) {
        return p.cities.forEach(function (c) {
          return c.districts.forEach(function (d) {
            if (d.occupied) count++;
          });
        });
      });
      return count;
    },
    freeCount: function freeCount() {
      return this.totalCount - this.occupiedCount;
    },
    occupyRate: function occupyRate() {
      if (this.totalCount === 0) return 0;
      return (this.occupiedCount / this.totalCount * 100).toFixed(1);
    }
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this3 = this;

      this.loading = true;
      Promise.all([areaList({}), agentList({})]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            areaRes = _ref2[0],
            agentRes = _ref2[1];

        _this3.areaTree = areaRes || [];
        var agentData = agentRes && agentRes.data ? agentRes.data : agentRes;
        var rows = agentData && agentData.rows || [];
        var map = {};
        rows.forEach(function (row) {
          if (row.district) {
            map[row.district] = row;
          }
        });
        _this3.agentMap = map;
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    onFilterChange: function onFilterChange() {},
    onDistrictClick: function onDistrictClick(district) {
      var _this4 = this;

      this.editDialog = {
        visible: true,
        occupied: district.occupied,
        districtId: district.id,
        districtCode: district.code,
        provinceName: district.provinceName,
        cityName: district.cityName,
        districtName: district.name,
        number: district.agentNumber || '',
        submitLoading: false,
        delLoading: false
      };
      this.$nextTick(function () {
        if (_this4.$refs.editForm) {
          _this4.$refs.editForm.clearValidate();
        }
      });
    },
    onSubmitAgent: function onSubmitAgent() {
      var _this5 = this;

      this.$refs.editForm.validate(function (valid) {
        if (!valid) return;
        _this5.editDialog.submitLoading = true;
        var data = {
          number: _this5.editDialog.number,
          province: _this5.editDialog.provinceName,
          city: _this5.editDialog.cityName,
          district: _this5.editDialog.districtId
        };
        agentHandle(data).then(function (res) {
          _this5.$message({
            message: _this5.editDialog.occupied ? '修改成功' : '添加成功',
            type: 'success'
          });

          _this5.editDialog.visible = false;
          _this5.editDialog.submitLoading = false;

          _this5.loadData();
        }).catch(function () {
          _this5.editDialog.submitLoading = false;
        });
      });
    },
    onRemoveAgent: function onRemoveAgent() {
      var _this6 = this;

      this.$confirm("\u786E\u8BA4\u79FB\u9664\u300C".concat(this.editDialog.districtName, "\u300D\u7684\u4EE3\u7406\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.editDialog.delLoading = true;
        agentDelete({
          number: _this6.editDialog.number
        }).then(function (res) {
          _this6.$message({
            message: '移除成功',
            type: 'success'
          });

          _this6.editDialog.visible = false;
          _this6.editDialog.delLoading = false;

          _this6.loadData();
        }).catch(function () {
          _this6.editDialog.delLoading = false;
        });
      }).catch(function () {});
    }
  }
};